// extracted by mini-css-extract-plugin
export default {"container":"AddPointsDialog_container__05c+P","label":"AddPointsDialog_label__SIlMc"};